import React from 'react';
import VstComponent from './VstComponent';

class VstTableRow extends VstComponent {

  render() {
    return (
      <tr
        style={{ cursor: (this.props.onClick ? 'pointer' : '') }}
        onClick={this.props.onClick}
        tabIndex={0}
      >
        {this.props.children}
        <td
          className="vst-table-col-hidden"
        >
          {this.props.onClick && <button tabIndex="-1" onClick={this.props.onClick}>Select</button>}
        </td>
      </tr>
    );
  }
}

export default VstTableRow;
